export default "__VITE_ASSET__DSwNxPvm__"